import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { PURPOSEOFUSEOPTIONS, SUBMIT_REQUEST_TITLE } from "../../../../../../constants/external-constants";
import {
    OR_RRF_TextArea as TextArea
    , ORFButton as Button
} from '../../../../../common/forms/order-request-form.component';
import { SelectFieldFloatingLabel } from '../../../../../../components/common/custom-form/select-filter.component';
import { wirelessPortInActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { withRouter } from 'react-router-dom';
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import store from '../../../../../../store';
import { ConfirmationNotificationModal } from '../../../../../common/modal/confirmation-modal.component';
import { MAX_LENGTH } from '../../../../../../constants/external-constants'; 
class PortInBusinessFormA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showConModal:false,
            isSaving:false,
            disableBusinessJustification: false
        };
    }

    submitRequest = async () => {        
        this.setState({showConModal:true})
    }
  
    handleCloseNotif = () => {
        this.setState({ show: false });
        this.props.history.goBack();
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {            
            const { submitRequest, fetchRequestLogItems } = this.props;
            const orderId = this.props.match.params.orderId;
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest(orderId);
            if (success.Success) {
                fetchRequestLogItems(0);
                this.props.hideRequestModal();
            }
                    
            this.setState({
                showConModal: false,
                show: true,
                isSaving: false,
                message: success.Message
            });
        }else{
            this.setState({
                showConModal: false
            });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    toReduceOptions = (obj) => {
        return obj?.filter(obj => obj.Value !== PURPOSEOFUSEOPTIONS.directLine && obj.Value !== PURPOSEOFUSEOPTIONS.backupLine)
    }

    onChangeBusinessCase(model, value) {
        const { businessCaseOptions } = this.props.wirelessPortInRequest;

        var disableBusinessJustification = businessCaseOptions.findIndex(r => parseInt(r.Key) === parseInt(value) && r.Value.toLowerCase() !== 'other') > -1;
        var businessCaseSelected = businessCaseOptions.find(r => parseInt(r.Key) === parseInt(value));
        var businessJustificationValue = disableBusinessJustification === true ? businessCaseSelected?.Value : "";

        store.dispatch(actions.change(model, value));
        store.dispatch(actions.change("wirelessPortInBusinessFormA.businessJustification", businessJustificationValue));
        this.setState({
            disableBusinessJustification: disableBusinessJustification
        });
    }

    render() {
        const {
            // component props
            prevAction
            , onClickCancel
            //form
            , wirelessPortInLocationFormA
            , wirelessPortInBusinessFormA
            , wirelessPortInSubscriptionFormA
            , createRequest
        } = this.props;
        const { purposeOfUseOptions, businessCaseOptions, formSubmitting } = this.props.wirelessPortInRequest;
        const { requestData } = this.props.requestDetail;
        const showAcceptRequestSubmit = !wirelessPortInSubscriptionFormA.equipmentInventoryId.valid;
        const initialRequired = wirelessPortInBusinessFormA.purposeOfUseId == 0
            || wirelessPortInBusinessFormA.businessJustification == ''
            || wirelessPortInBusinessFormA.busJustiCodeDetailId == 0
            || (showAcceptRequestSubmit && !wirelessPortInBusinessFormA.termAgreement)
            || formSubmitting;
        const updateRequired = !((requestData.OtherLocationName !== '' ? requestData.OtherLocationName !== wirelessPortInLocationFormA.otherDeliveryAddress.value : wirelessPortInLocationFormA.otherDeliveryAddress.value != null)
            || (parseInt(wirelessPortInLocationFormA.locationId.value) !== -1 ? (parseInt(requestData.Location.LocationId) !== parseInt(wirelessPortInLocationFormA.locationId.value)) : (parseInt(requestData.OtherLocationID) !== parseInt(wirelessPortInLocationFormA.otherDeliveryAddressId.value)))
            || requestData.Location.CountryCode !== wirelessPortInLocationFormA.countryCode.value
            || requestData.Subscription.PersonalMobile !== wirelessPortInSubscriptionFormA.personalMobile.value
            || requestData.Subscription.CurrentVendor !== wirelessPortInSubscriptionFormA.currentVendor.value
            || requestData.Subscription.AccountNumber !== wirelessPortInSubscriptionFormA.accountNumber.value
            || requestData.Subscription.PortPinCode !== wirelessPortInSubscriptionFormA.portPinCode.value
            || requestData.Subscription.CurrentBillingAddress !== wirelessPortInSubscriptionFormA.currentBillingAddress.value
            || parseInt(requestData.Subscription.EquipmentInventoryId) !== parseInt(wirelessPortInSubscriptionFormA.equipmentInventoryId.value)
            || parseInt(requestData.Subscription.PlanId) !== parseInt(wirelessPortInSubscriptionFormA.planId.value)
            || requestData.Subscription.PhoneCaseAccessory !== wirelessPortInSubscriptionFormA.phoneCaseAccessory.value
            || parseInt(requestData.Subscription.EquipmentCatalogId) !== parseInt(wirelessPortInSubscriptionFormA.equipmentCatalogId.value)
            || parseInt(requestData.Subscription.CircuitTypeId) !== parseInt(wirelessPortInSubscriptionFormA.circuitTypeId.value)
            || parseInt(requestData.Subscription.VendorDetailId) !== parseInt(wirelessPortInSubscriptionFormA.vendorDetailId.value)
            || parseInt(requestData.BusinessJustification.PurposeOfUseId) !== parseInt(wirelessPortInBusinessFormA.purposeOfUseId)
            || parseInt(requestData.BusinessJustification.BusJustiCodeDetailId) !== parseInt(wirelessPortInBusinessFormA.busJustiCodeDetailId)
            || requestData.BusinessJustification.BusinessJustification !== wirelessPortInBusinessFormA.businessJustification
            || requestData.BusinessJustification.AdditionalInformation !== wirelessPortInBusinessFormA.additionalInformation);
        const disableBusinessJustificationTextbox = parseInt(wirelessPortInBusinessFormA.busJustiCodeDetailId) === 0 || businessCaseOptions.findIndex(r => parseInt(r.Key) === parseInt(wirelessPortInBusinessFormA.busJustiCodeDetailId) && r.Value.toLowerCase() !== 'other') > -1;
        return (
            <div className="portin-subscription-container" >

                <NotificationModal
                    show={this.state.show}
                    title="Success"
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />

                <ConfirmationNotificationModal 
                    show={this.state.showConModal}
                    message={createRequest.isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                    title={createRequest.isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />

                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <SelectFieldFloatingLabel
                            className="form-select required"
                            label={`${this.toLocaleLanguage('purpose_of_use')}`}
                            options={this.toReduceOptions(purposeOfUseOptions)}
                            placeholder={this.toLocaleLanguage('select_placeholder')}
                            fieldProp='wirelessPortInBusinessFormA.purposeOfUseId'
                            value={wirelessPortInBusinessFormA.purposeOfUseId}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <SelectFieldFloatingLabel
                            className="form-select required"
                            label={`${this.toLocaleLanguage('business_case')}`}
                            value={wirelessPortInBusinessFormA.busJustiCodeDetailId}
                            options={businessCaseOptions}
                            placeholder={this.toLocaleLanguage('select_placeholder')}
                            fieldProp='wirelessPortInBusinessFormA.busJustiCodeDetailId'
                            onChangeAction={(model, value) => this.onChangeBusinessCase(model, value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea' >
                        <TextArea
                            label={this.toLocaleLanguage('business_justification')}
                            fieldProp='wirelessPortInBusinessFormA.businessJustification'     
                            placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            value={wirelessPortInBusinessFormA.businessJustification}
                            disabled={this.state.disableBusinessJustification || disableBusinessJustificationTextbox}
                            maxLength={MAX_LENGTH.limit_500}
                        />                      
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <TextArea
                            label={this.toLocaleLanguage('additional_information')}
                            placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            fieldProp='wirelessPortInBusinessFormA.additionalInformation'
                            value={wirelessPortInBusinessFormA.additionalInformation}
                            maxLength={MAX_LENGTH.limit_1000}
                        />
                      
                    </Col>
                </Row>

                {
                    showAcceptRequestSubmit
                    && <ControlCheckBox
                        isRequired={true}
                        label={`${this.toLocaleLanguage('accept_request_submit_port_in')}`}
                        model="wirelessPortInBusinessFormA.termAgreement"
                        checked={wirelessPortInBusinessFormA.termAgreement}
                    />
                }
                <div className="request-button-continer">
                    <div className="bottom-left">
                        <Button
                            label={this.toLocaleLanguage('modal_close_cancel_button')}
                            variant={"light"}
                            action={onClickCancel}
                            type="button"
                            disabled={formSubmitting}
                        />
                    </div>
                    <div className="bottom-right">
                        <div>
                            <Button
                                label={this.toLocaleLanguage('back')}
                                variant={"outline-secondary"}
                                action={prevAction}
                                disabled={formSubmitting}
                                className="btn-custom-violet-hover-outline"
                            />
                        </div>
                        <div>
                            <Button
                                type={"submit"}
                                label={this.toLocaleLanguage('submit_request_button')}
                                variant={"primary"}
                                disabled={createRequest.isUpdateRequest ? (initialRequired || updateRequired) : initialRequired }
                                action={this.submitRequest}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
export default withRouter (connect(
    state => {
        const { wirelessPortInRequest, translation, requestDetail, createRequest } = state;
        const { wirelessPortInBusinessFormA } = state.form;
        const { wirelessPortInSubscriptionFormA, wirelessPortInLocationFormA } = state.form.forms;
        return {
            wirelessPortInRequest
            , wirelessPortInBusinessFormA
            , wirelessPortInSubscriptionFormA
            , wirelessPortInLocationFormA
            , createRequest
            , requestDetail
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelessPortInActions, requestLogActions),
            dispatch
        )
)(PortInBusinessFormA));